<template>
  <div class="info">
    <div
      class="info-item"
      :style="{width: item.width || itemWidth}"
      v-for="item in infoOptions"
      :key="item.prop"
    >
      <div class="item-label" :style="{ width: labelWidth + 'px' }">{{item.label}}:</div>
      <div class="item-value">{{infoData[item.prop] || '————'}}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BaseInfo',
  props: {
    // 值
    infoData: {
      type: Object,
      default: () => ({})
    },
    // 配置
    infoOptions: {
      type: Array,
      default: () => []
    },
    // 全局labelwidth
    labelWidth: {
      type: String,
      default: '90'
    },
    // 全局item宽度
    itemWidth: {
      type: String,
      default: '23%'
    }

  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.info {
  width: 100%;
  display: flex;
  padding: 10px 0px;
  flex-wrap: wrap;
  .info-item {
    width: 33%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 8px 5px;
    .item-label {
      flex-shrink: 0;
      width: 80px;
      text-align: right;
      color: #888;
    }
    .item-value {
      flex: 1;
      text-align: left;
      margin-left: 10px;
      color: #333;
    }
  }
}
</style>
